// Static data for Cresta Bath & Tile site

export const CONTACT = {
  phone: "(343) 987 9604",
  phoneHref: "tel:+13439879604",
  email: "info@crestabath.ca",
  emailHref: "mailto:info@crestabath.ca",
  area: "Ottawa & Surrounding Areas",
  hours: "Mon – Sat · 8:00 – 18:00",
};

export const MEDIA = {
  hero: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/of6q7tok_image.png",
  services: {
    tub: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/c50a6mh3_image.png",
    full: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/fgh1tppy_image.png",
    tile: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/87opx9p8_image.png",
  },
  process: [
    "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/fw700zue_image.png",
    "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/z0lbifgd_image.png",
  ],
  gallery: [
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/of6q7tok_image.png", tag: "Tub-to-Shower", span: "col-span-2 row-span-2" },
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/5191jsw2_image.png", tag: "Full Renovation", span: "col-span-1 row-span-1" },
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/fgh1tppy_image.png", tag: "Full Renovation", span: "col-span-1 row-span-2" },
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/hy8zd9m4_image.png", tag: "Custom Tiling", span: "col-span-2 row-span-1" },
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/h07j4t71_image.png", tag: "Full Renovation", span: "col-span-1 row-span-1" },
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/c50a6mh3_image.png", tag: "Tub-to-Shower", span: "col-span-1 row-span-1" },
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/wjf18cne_image.png", tag: "Tub-to-Shower", span: "col-span-1 row-span-1" },
    { src: "https://customer-assets.emergentagent.com/job_tub-to-shower/artifacts/3t803ugg_image.png", tag: "Custom Tiling", span: "col-span-1 row-span-1" },
  ],
};

export const SERVICES = [
  {
    id: "tub-to-shower",
    overline: "Service 01",
    title: "Tub-to-Shower Conversions",
    duration: "3 – 5 days",
    image: MEDIA.services.tub,
    description:
      "Trade an underused tub for an effortless, spa-grade walk-in shower. Clean lines, frameless glass, matte-black hardware — finished in under a week with minimal disruption to your home.",
    bullets: [
      "Demolition & disposal handled in-house",
      "Schluter waterproofing system",
      "Frameless or low-profile glass",
      "Matte black, brushed nickel or chrome trim",
    ],
  },
  {
    id: "full-renovation",
    overline: "Service 02",
    title: "Full Turn-Key Renovations",
    duration: "2 – 4 weeks",
    image: MEDIA.services.full,
    description:
      "Walls down, layout reimagined. We re-engineer your bathroom from the studs out — plumbing, electrical, advanced waterproofing, custom layout, lighting and finishing. One contract, one team, one impeccable result.",
    bullets: [
      "Full design & 3D layout consultation",
      "Custom vanities, floating cabinetry",
      "Heated floors & integrated lighting",
      "5-year workmanship warranty",
    ],
  },
  {
    id: "custom-tiling",
    overline: "Service 03",
    title: "Premium Custom Tiling",
    duration: "By project",
    image: MEDIA.services.tile,
    description:
      "Large-format porcelain slabs, book-matched calacatta, custom shower niches and laser-precise geometry. The kind of tile work people stop and notice.",
    bullets: [
      "Large-format porcelain & calacatta slabs",
      "Book-matched veining alignment",
      "Custom shower niches & benches",
      "Laser-leveled installation",
    ],
  },
];

export const SERVICES_EXTRA = [
  {
    id: "drywall",
    icon: "Layers",
    title: "Drywall",
    tagline: "Walls that stay flat.",
    description:
      "Full drywall installation, patching and moisture-resistant boards for wet areas. Level-5 finish on request — the kind that survives raking side-light without a single flaw.",
    bullets: ["Moisture-resistant board for baths & laundry", "Skim-coat & Level-5 finish", "Ceilings, bulkheads & niches"],
  },
  {
    id: "painting",
    icon: "PaintBucket",
    title: "Interior Painting",
    tagline: "Clean lines, no drips.",
    description:
      "Interior painting done the calm way — proper prep, dust-controlled sanding, premium low-VOC paints and taped, laser-straight lines against tile and trim.",
    bullets: ["Full prep, priming & sanding", "Benjamin Moore / Farrow & Ball on request", "Trim, doors, ceilings & accent walls"],
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Consultation", body: "On-site visit. We measure, listen, and understand exactly how you live." },
  { n: "02", title: "Design", body: "Fixed-price quote with material selections, layout drawings, and timeline." },
  { n: "03", title: "Demo & Prep", body: "Clean demolition. Dust containment. Plumbing & electrical roughed in." },
  { n: "04", title: "Waterproofing", body: "Schluter / Kerdi membrane system. Inspected before a single tile is set." },
  { n: "05", title: "Install", body: "Laser-leveled tile, custom niches, frameless glass, fixtures." },
  { n: "06", title: "Reveal", body: "Final walkthrough. Spotless handover. 5-year workmanship warranty." },
];

export const TESTIMONIALS = [
  {
    quote:
      "We've renovated three properties in Ottawa and have never had a contractor this organized. The tile work alone is worth every dollar — book-matched calacatta that looks like a hotel.",
    author: "Marie L.",
    location: "Glebe, Ottawa",
  },
  {
    quote:
      "From the quote to the final clean, Cresta was on time, on budget, and detail-obsessed. Our basement bathroom now feels nicer than the one upstairs.",
    author: "Daniel & Priya R.",
    location: "Kanata",
  },
  {
    quote:
      "Five days. Old tub out, walk-in shower in, completely transformed. I keep finding excuses to show people.",
    author: "Sandra B.",
    location: "Orléans",
  },
];

export const TRUST_STATS = [
  { value: "100+", label: "Bathrooms transformed across the Ottawa region" },
  { value: "5 yr", label: "Workmanship warranty on every renovation" },
  { value: "3 – 5", label: "Days for a complete tub-to-shower conversion" },
  { value: "100%", label: "Licensed, insured & WSIB compliant" },
];

export const PROJECT_TYPES = [
  "Tub-to-Shower Conversion",
  "Full Bathroom Renovation",
  "Custom Tiling Only",
  "Drywall",
  "Interior Painting",
  "Powder Room",
  "Not sure yet — need advice",
];

export const BUDGETS = [
  "Under $10,000",
  "$10,000 – $20,000",
  "$20,000 – $35,000",
  "$35,000 – $60,000",
  "$60,000+",
];

export const TIMELINES = [
  "ASAP",
  "Within 1 month",
  "1 – 3 months",
  "3 – 6 months",
  "Just exploring",
];
